export default {
  algolia_app_id: 'PN2KDF9HET',
  algolia_api_key: '502f4fb4e462b2d151b10af219607f23',
  algolia_monitoring_api_key: '2fd089ae817e14b0d8c89072f5743c6d',
  markers: {},
  id: 5,
  name: 'Experts',
  meta_description: 'Find an expert in the Coastal Virginia area.',
  hero_text: 'Find an Expert',
  hero_uri: 'https://s3-us-west-2.amazonaws.com/directory.covamd.com/hero_uri.jpg',
  logo_uri: 'https://i.imgur.com/7O9ObKM.png',
  listing_ad: 'https://s3-us-west-2.amazonaws.com/directory.covamd.com/listing-ad.jpeg',
  banner_ad: 'https://s3-us-west-2.amazonaws.com/directory.covamd.com/banner.jpg',
  header_ad: 'https://s3-us-west-2.amazonaws.com/directory.covamd.com/headerad.gif',
  latlng: { lat: 36.8529, lng: -75.9780 },
  total_records: 0,
  style_settings: {},
  expert: {
    enabled: true,
    criteria: [
      'Currently full-time in the industry.',
      'Valid license with no disciplinary history in the last 5 years.',
      'You\'ve been in full - time practice for at least 10 years.',
      'Your company generates more than $500k in annual revenue.',
    ],
  },
  directories: {
    lawyers: {
      id: 1,
      name: 'Lawyers',
      slug: 'lawyers',
      hero_uri: 'https://www.coastalvirginiamag.com/images/cache/cache_8/cache_1/cache_c/Scales_and_Gavel_176165213_std-7ced6c18.jpeg?ver=1488331920&aspectratio=1.5031315240084',
      algolia_index: 'coastal-virginia-magazine_lawyers',
      badge_text: 'Legal Elite',
      secondary_search_data_point: 'awards',
      fields: {
        awards: {
          name: 'Legal Elite',
          key: 'awards',
          type: 'string',
          facet: true,
          searchable: true,
          free: true,
        },
        'locations.city': {
          name: 'City',
          key: 'locations.city',
          type: 'array',
          facet: true,
        },
        'locations.name': {
          name: 'Office',
          key: 'locations.name',
          type: 'array',
          facet: true,
        },
      },
      created_at: '2018-09-07 18: 39: 24',
      updated_at: '2018-09-07 18: 39: 24',
    },
  },
};
